import { Tag as AlphaTag } from '@oneaudi/unified-web-alpha-components';

export default AlphaTag;
